import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import TemplePOS from '@/components/TemplePOS'

const templePOS = () => {
  return (
    <>
      <Head>
        <title>Temple POS - Temple Management Software & Temple POS System</title>
        <link rel="canonical" href="https://queuebuster.co/temple-pos" />
        <link rel="alternate" href="https://queuebuster.co/temple-pos" hrefLang="en-us" />
        <meta name="description" content="Streamline temple operations with QueueBuster POS. Manage donations, Pooja bookings, inventory, and more with ease and security." />
        <meta property="og:title" content="QueueBuster Temple POS Solution - Enhance Temple Operations" />
        <meta property="og:description" content="Discover the QueueBuster Temple POS Solution, designed for religious centers and nonprofits. Efficiently manage donations, Pooja bookings, inventory, and events with a secure, customizable system. Improve operations and build trust with automated features and real-time updates." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-08.jpg" />
        <meta property="og:url" content="https://queuebuster.co/temple-pos" />
      </Head>
      <TemplePOS />
    </>
  )
}

export default templePOS